module.exports = __webpack_public_path__ + "static/img/icon-pack-down.70573cb6.svg";